class ErrorUtils {
  extractErrorMessage (error) {
    return (error.response
      && error.response.data
      && error.response.data.message
      && error.response.data.message.split(':')[0])
      || error.message;
  }

  extractInfoFromError (error, propertyName) {
    return error.response
      && error.response.data
      && error.response.data.info
      && error.response.data.info[propertyName];
  }
}

export default new ErrorUtils();
